import React, { ChangeEvent } from "react";

interface TextareaProps {
  change_handler: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  value?: string;
  other_classes?: string;
  name: string;
  maxLength?: number
}

const Textarea: React.FC<TextareaProps> = ({
  name,
  value,
  placeholder,
  change_handler,
  other_classes,
  maxLength
}) => {
  return (
    <textarea
      maxLength={maxLength ? maxLength : 5000}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={(e)=>change_handler(e)}
      className={`w-full h-24 text-sm px-3 py-2 border border-[#E6E6E6] placeholder:text-sm placeholder:font-light placeholder-[#999999] rounded ${other_classes}`}
    />
  );
};

export default Textarea;
